import React, { useCallback, useState } from "react";
import { Select } from "components/Select/Select";
import { InputCardTitle } from "components/InputCards/InputCardTitle";
import { TooltipIcon } from "./TooltipIcon";

export const SelectCard = ({
  label,
  options,
  value,
  disabled,
  handleChange,
  partKey,
  optionKey,
  description,
  handlePartClick,
  menuPlacement,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const onChange = useCallback(
    (e) => {
      setIsLoading(true);
      handleChange(e);
    },
    [handleChange],
  );

  return (
    <>
      <TooltipIcon description={description} />
      <InputCardTitle
        title={label}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <Select
        name={`config-${partKey}-${optionKey}`}
        data-recording-disable={true}
        options={options}
        onChange={onChange}
        isDisabled={disabled}
        value={value}
        testId={`select-${partKey}-${optionKey}`}
        onMenuOpen={handlePartClick}
        menuShouldScrollIntoView={false}
        menuPlacement={menuPlacement}
      />
    </>
  );
};
